import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store= {store}>
        <App />
    </Provider>
    
  </React.StrictMode>
);

//installed npm install react-redux
//npm install redux
//npm install react-router-dom